module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAQAAAD9CzEMAAAAwklEQVR4Ae2WAQbDQBBFB8ndAgL2kCW0VPRsiV19xRwg36eL2HeA/9idmZkYDAb3hYmNEiIUNqbQYWYHGkWMb8DOrAveJI01LmClkTx1wcJJUlkv4ivJyRLhK/R4X6HH64pKUln8ePmFZbmvkJ/PV1jxaqWnwowXejU5OIUm9BWJMEYsxdeP1wRNFvR/Ir2ODg7/k6VO0Mu0f6P1HxX+sOs/rnstnA4r01j6zVDw0puJYpwt1uH1Yf7n6fhgitsyGAx+v01bGP41zTEAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/components/Snackbar/baseline_clear_white_24dp.png
// module id = 82
// module chunks = 0